import {
  Translation,
} from '@o3r/core';

export interface ChallengeTranslation extends Translation {
  /**
   * The translation key for the title of the panel for trip
   */
  viewTripTitle: string;
}

export const translations: ChallengeTranslation = {
  viewTripTitle: 'refx-servicing-challenge.viewTripTitle'
};
